module.exports = __webpack_public_path__ + "img/paypal_logo.ce465344.jpg";